import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { OrdersApiPaths } from 'Feature/Orders/Common/Constant/OrdersApiPaths';

import { IGenerateHomePageUrlQuery } from 'Feature/Orders/Common/types/Queries/IGenerateHomePageUrlQuery';

export const generateHomePageUrl = createAsyncThunk(
  'Order/generateHomePageUrl',
  async (query: IGenerateHomePageUrlQuery) => {
    return await OrdersHttpGetService({
      url: `${OrdersApiPaths.Order.GenerateHomePageUrl}`,
      params: query,
    });
  }
);
